import { Box, CircularProgress } from '@material-ui/core';
import { useAppContext } from 'core/contexts';
import React from 'react';

type Props = {
    className?: string;
};

const PageHeaderTitleIncapacite: React.FC<Props> = () => {
    const { headerTitle } = useAppContext();
    return (
        <Box>
            {headerTitle ? (
                <>
                    <Box display={'flex'} flexDirection={'row'} alignItems="baseline" style={{ height: '25px' }}>
                        <Box>SALARIÉ : </Box>
                        <Box style={{ color: '#FFF' }} className="ml-2">
                            {headerTitle?.nom} {headerTitle?.prenom}{' '}
                        </Box>{' '}
                        <Box className="ml-2" style={{ fontSize: '0.8rem' }}>
                            (NIR: {headerTitle?.numSecu})
                        </Box>
                    </Box>
                </>
            ) : (
                <Box display={'flex'} flexDirection={'row'}>
                    <CircularProgress
                        style={{ width: '20px', height: '20px' }}
                        color="primary" // You can set the color as needed
                    />
                    <Box className="ml-2">Chargement ...</Box>
                </Box>
            )}
        </Box>
    );
};

export default PageHeaderTitleIncapacite;
